import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-418657f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header__main" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "df-c" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header__title" }, "Единая Государственная Автоматизированная Информационная Система"),
  /*#__PURE__*/_createElementVNode("span", { class: "header__subtitle" }, " Федеральная служба по контролю за алкогольным и табачным рынками ")
], -1))
const _hoisted_4 = {
  key: 0,
  class: "header__breadcrumbs"
}
const _hoisted_5 = { class: "header__controls" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_breadcrumbs = _resolveComponent("breadcrumbs")!
  const _component_report_mode_toggle = _resolveComponent("report-mode-toggle")!
  const _component_scale_switcher = _resolveComponent("scale-switcher")!
  const _component_print = _resolveComponent("print")!

  return (!_ctx.$route.meta.withoutHeader)
    ? (_openBlock(), _createElementBlock("header", {
        key: 0,
        class: _normalizeClass(["header invert", {
			'transparent': _ctx.transparent,
			'fixed': _ctx.fixed,
			'header--print-logo': _ctx.$route.meta.printLogo
		}])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "header__logo"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: require('@/shared/assets/header/logo.png'),
                alt: "gerb"
              }, null, 8, _hoisted_2),
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        (_ctx.breadcrumbs)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_breadcrumbs),
              _createElementVNode("div", _hoisted_5, [
                (_ctx.$route.meta.slideMode)
                  ? (_openBlock(), _createBlock(_component_report_mode_toggle, { key: 0 }))
                  : _createCommentVNode("", true),
                _createVNode(_component_scale_switcher),
                _createVNode(_component_print, { class: "page__print" })
              ])
            ]))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}